"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadData = exports.copy = exports.remove = exports.list = exports.getUrl = exports.getProperties = void 0;
// Pattern 6 (Phase C4): the read APIs are bare re-exports of the ctx-native
// main S3 APIs (they already accept `(ctx, input)` via overloads, so the
// previous per-API `resolveServerContext` wrappers are gone). `uploadData`
// keeps a server-specific entry because its task type intentionally omits
// pause/resume across isolated server requests.
var __1 = require("..");
Object.defineProperty(exports, "getProperties", { enumerable: true, get: function () { return __1.getProperties; } });
Object.defineProperty(exports, "getUrl", { enumerable: true, get: function () { return __1.getUrl; } });
Object.defineProperty(exports, "list", { enumerable: true, get: function () { return __1.list; } });
Object.defineProperty(exports, "remove", { enumerable: true, get: function () { return __1.remove; } });
Object.defineProperty(exports, "copy", { enumerable: true, get: function () { return __1.copy; } });
var apis_1 = require("../../../../server/apis");
Object.defineProperty(exports, "uploadData", { enumerable: true, get: function () { return apis_1.uploadData; } });
